import { API, API_GET } from "../../../Config"


export const GetWorkout = () => {
  return (
    API_GET(API.GetWorkout)
  )
}

